const PATIENT_GENDERS = ["MALE", "FEMALE", "OTHER"];
export function toPatientGender(value) {
    const normalized = value?.trim().toUpperCase();
    return PATIENT_GENDERS.find((gender) => gender === normalized) ?? "OTHER";
}
